import { ITokenStorage, TokenContainer } from "@axl-dev/school-sdk";
import cookies, { CookieAttributes } from 'js-cookie';
import CookieStorage from "./cookie-storage";

const LC_KEY = "SCHOOL_TOKENS";

export class LSTokenStorage implements ITokenStorage {
  tokens: TokenContainer | null;

  async getTokens(): Promise<TokenContainer | null> {
    const lcValue = localStorage.getItem(LC_KEY);
    if (!lcValue) return null;
    try {
      return JSON.parse(lcValue);
    } catch {
      return null;
    }
  }

  async setTokens(tokens: TokenContainer | null): Promise<void> {
    if (tokens) {
      this.tokens = tokens;
      localStorage.setItem(LC_KEY, JSON.stringify(tokens));
    } else {
      this.tokens = null;
      localStorage.removeItem(LC_KEY);
    }
  }
}

const COOKIE_ACCESS_TOKEN_NAME = "student_access_token";
const COOKIE_REFRESH_TOKEN_NAME = "student_refresh_token";

export class CookieTokenStorage implements ITokenStorage {
  tokens: TokenContainer | null;
  private cookieStorage: CookieStorage;

  constructor() {
    this.cookieStorage = new CookieStorage();
  }

  async getTokens(): Promise<TokenContainer | null> {
    const accessToken = this.cookieStorage.get(COOKIE_ACCESS_TOKEN_NAME);
    const refreshToken = this.cookieStorage.get(COOKIE_REFRESH_TOKEN_NAME);
    if (!accessToken || !refreshToken) return null;
    return {
      accessToken,
      refreshToken,
    };
  }

  async setTokens(tokens: TokenContainer | null): Promise<void> {
    if (tokens) {
      this.cookieStorage.set(COOKIE_ACCESS_TOKEN_NAME, tokens.accessToken);
      this.cookieStorage.set(COOKIE_REFRESH_TOKEN_NAME, tokens.refreshToken);
    } else {
      this.cookieStorage.remove(COOKIE_ACCESS_TOKEN_NAME);
      this.cookieStorage.remove(COOKIE_REFRESH_TOKEN_NAME);
    }
    this.tokens = tokens;
  }
}